const ItemBody = ({
  previewKey,
  image,
  previewItem,
  previewIsSelected,
  isCategoryShow,
  selectPreview,
  previewSelected,
  uploadElement,
  styleHeight,
  previewStyle,
  imageDownload,
  imageName,
  imageWidth,
  imageHeight,
  positionX,
  positionY,
  showPreviewEditPopup,
  dispatch,
  analytics,
  previewCategory,
  clickUpdateHandler,
  itemBodyClickUpdateHandler
}) => {
  if (image && isCategoryShow) {
    previewStyle["backgroundImage"] = `url(${image})`;
  }

  return (
    <figure className="preview__item-image" style={previewStyle}>
      <span
        className={`preview__item-size ${
          styleHeight < 90 ? "preview__item-size_min" : ""
        }`}
      >
        {previewItem.width}&times;{previewItem.height}
      </span>
      <label style={{ fontSize: 0 }}>
        select image
        <input
          type="checkbox"
          onChange={() => {
            analytics.sendSelectPreview(
              previewCategory,
              imageName,
              `${previewItem.width}&times;${previewItem.height}`
            );
            dispatch(selectPreview(previewSelected, previewKey));
          }}
          checked={previewIsSelected}
          className={`preview__item-select  ${
            styleHeight < 90 ? "preview__item-select_min" : ""
          }`}
        />
      </label>
      <div
        className={`preview__item-action ${
          styleHeight < 200 ? "preview__item-action_line" : ""
        }`}
      >
        {!image ? (
          <button
            onClick={() => {
              itemBodyClickUpdateHandler(analytics.sendClickUpload, uploadElement)
             }}
          >
            Upload
          </button>
        ) : (
          <></>
        )}
        {image ? (
          <button
            onClick={() => {
              analytics.sendEditPreview(
                previewCategory,
                imageName,
                `${previewItem.width}&times;${previewItem.height}`
              );
              clickUpdateHandler(previewKey, showPreviewEditPopup, dispatch);
            }}
          >
            Edit
          </button>
        ) : (
          <></>
        )}
        {image ? (
          <button
            onClick={() => {
              analytics.sendDownloadPreview(
                previewCategory,
                imageName,
                `${previewItem.width}&times;${previewItem.height}`
              );
              imageDownload(
                imageName,
                image,
                imageWidth,
                imageHeight,
                previewItem.width,
                previewItem.height,
                positionX,
                positionY
              );
            }}
            className="download"
          >
            Download
          </button>
        ) : (
          <></>
        )}
      </div>
    </figure>
  );
};

export default ItemBody;
